import React,{useState,useMemo,useContext,Fragment}from'react';// @ts-ignore
var Context = React.createContext(null);/**
 * Replace pure {value} variables
 *
 * message: "Price - ${value}"
 * values: { value: 100 }
 *
 * result: Price - $100
 */
var replaceSimpleVariables = function (message, values) {
    if (values === void 0) { values = {}; }
    // there is no way to math variables first and then iterate by them, coz if we try to find {variable} we match
    // variables in variables - {sex, select, female {perfume} male {cologne} unisex {fragrance}}
    return Object.keys(values).reduce(function (res, key) {
        // @ts-ignore
        var value = values[key];
        if (value === null || value === undefined) {
            return res;
        }
        // prevent of replacing value in variables (that matching the variable name)
        // example message - 'Some {key} with {check, plural, one {key} other {something}}'
        // const escapeFormulasRegexp = `{${key}}(?!([^{]+)?(({[^{}]+}([^{}]+)?)+)?})`
        //
        // here the ductape "() => values[key]" to fix Safari 11.* bug - '{value}'.replace(/{value}/g, '$14.95') becomes '4.95'
        return res.replace(new RegExp("{".concat(key, "}"), 'g'), function () { return value; });
    }, message);
};// CLDR - https://www.unicode.org/cldr/charts/34/supplemental/language_plural_rules.html
var plural = {
    en: function (n, ord) {
        if (ord === void 0) { ord = false; }
        var s = String(n).split('.');
        var v0 = !s[1];
        var t0 = Number(s[0]) === n;
        var n10 = t0 && Number(s[0].slice(-1));
        var n100 = t0 && Number(s[0].slice(-2));
        if (n === 0) {
            return 'zero';
        }
        if (ord) {
            if (n10 === 1 && n100 !== 11) {
                return 'one';
            }
            if (n10 === 2 && n100 !== 12) {
                return 'two';
            }
            if (n10 === 3 && n100 !== 13) {
                return 'few';
            }
            return 'other';
        }
        if (n === 1 && v0) {
            return 'one';
        }
        if (n === 2 && v0) {
            return 'two';
        }
        return 'other';
    },
};/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}/**
 * variable: "{sex, select, female {perfume} male {cologne} unisex {fragrance}}"
 *
 * result: { female: 'perfume', male: 'cologne', unisex: 'fragrance' }
 */
var getVariableValues = function (variable) {
    // @ts-ignore
    return variable
        .match(/[^\s]+ {[^}]*}/g)
        .reduce(function (obj, item) {
        var _a;
        // @ts-ignore
        var _b = item.match(/(.+) {(.*)}/); _b[0]; var key = _b[1], value = _b[2];
        return __assign(__assign({}, obj), (_a = {}, _a[key] = value, _a));
    }, {});
};var variableRegex$1 = /{\w+, plural,(\s\w+ {#?[^#}]+}){2,}}/g;
/**
 * Replace variables with value based on passed values
 *
 * message: "{count, plural, one {# product} other {# products}}"
 * values: { count: 23 }
 *
 * result: 23 products
 */
var replacePluralVariables = function (message, values, locale) {
    var variables = message.match(variableRegex$1); // [ '{count, plural, one {# product} other {# products}}' ]
    if (variables === null || variables === void 0 ? void 0 : variables.length) {
        try {
            variables.forEach(function (variable) {
                var variableValues = getVariableValues(variable);
                // @ts-ignore
                var valueKey = variable.match(/[^,{]+/)[0]; // count
                var value = values ? values[valueKey] : null; // 23
                var variableKey;
                var result;
                // if value not passed set pluralKey value from the variable (first item) - other
                if (value === null || value === undefined) {
                    // TODO trigger error - added on 10/12/20 by pavelivanov
                    variableKey = 'other' in variableValues ? 'other' : Object.keys(variableValues)[0]; // eslint-disable-line
                    result = variableValues[variableKey].replace(/#\s?/g, ''); // products
                }
                else {
                    // @ts-ignore
                    variableKey = plural[locale](value); // other
                    if (!variableValues[variableKey]) {
                        variableKey = 'other';
                    }
                    result = variableValues[variableKey].replace(/#/g, value); // 23 products
                }
                message = message.replace(variable, result);
            });
        }
        catch (err) {
        }
    }
    return message;
};var variableRegex = /{\w+, select,(\s\w+ {[^}]+}){2,}}/g;
/**
 * Replace variables with value based on passed values
 *
 * message: "{sex, select, female {perfume} male {cologne} unisex {fragrance}}"
 * values: { sex: 'female' }
 *
 * result: perfume
 */
var replaceSelectVariable = function (message, values, variable) {
    var variableValues = getVariableValues(variable);
    var valueKey = variable.match(/(?!{)\w+/)[0]; // sex
    var variableKey = values ? values[valueKey] : null; // female
    // if value not passed set value from the variable (first item) - unisex
    if (!variableKey || !variableValues[variableKey]) {
        // TODO trigger error - added on 10/12/20 by pavelivanov
        variableKey = 'other' in variableValues ? 'other' : Object.keys(variableValues)[0]; // eslint-disable-line
    }
    var result = variableValues[variableKey]; // perfume
    return message.replace(variable, result);
};
var replaceSelectVariables = function (message, values) {
    var variables = message.match(variableRegex); // [ '{sex, select, female {perfume} male {cologne} unisex {fragrance}}' ]
    if (variables === null || variables === void 0 ? void 0 : variables.length) {
        try {
            variables.forEach(function (variable) {
                message = replaceSelectVariable(message, values, variable);
            });
        }
        catch (err) {
            console.error(err);
        }
    }
    return message;
};var stripSpaces = function (message) { return (message
    .replace(/\s{2,}/g, ' ')
    .replace(/<br\s?\/>\s+/g, '<br />')
    .replace(/{\s+/, '{')
    .replace(/\s+}/, '}')
    .trim()); };var formatMessage = function (locale, message, values) {
    if (locale === void 0) { locale = 'en'; }
    if (typeof message === 'string') {
        return message;
    }
    // TODO add error handler - added on 10/9/20 by pavelivanov
    if (!message) {
        return '{{ missed_translation }}';
    }
    // @ts-ignore
    var fMessage = stripSpaces(message[locale]);
    // @ts-ignore
    fMessage = replaceSelectVariables(fMessage, values);
    // @ts-ignore
    fMessage = replacePluralVariables(fMessage, values, locale);
    fMessage = replaceSimpleVariables(fMessage, values);
    return fMessage || '{{ missed_translation }}';
};// @ts-ignore
var createIntl = function (_a) {
    var locale = _a.locale, setLocale = _a.setLocale; _a.onError;
    return ({
        formatMessage: formatMessage.bind(null, locale),
        setLocale: setLocale,
    });
};var IntlProvider = function (props) {
    var children = props.children, initialLocale = props.locale, onError = props.onError;
    var _a = useState(initialLocale), locale = _a[0], setLocale = _a[1];
    var intl = useMemo(function () { return createIntl({ locale: locale, setLocale: setLocale, onError: onError }); }, [locale]);
    return (React.createElement(Context.Provider, { value: intl }, children));
};var useIntl = function () { return useContext(Context); };// <Button boolAttr1 valueAttr1="/queue" valueAttr2=" value " emptyAttr="" boolAttr2>content</Button>
var getComponentProps = function (message) {
    var props = {};
    if (/<\w+\s*\/>/.test(message)) {
        // @ts-ignore
        return;
    }
    var attrsPart = message
        .replace(/^<\w+\s+([^>]+?)\/?>.*/, '$1') // leave only part with attributes - 'boolAttr1 valueAttr1="/queue" valueAttr2=" value " emptyAttr="" boolAttr2'
        .replace(/\s*=\s*/g, '='); // strip spaces around `=`
    // to match all empty attributes with regex too complex, so
    var emptyProps = (attrsPart
        .replace(/\w+\s*=\s*["'].*?["']/g, '') // strip attributes with values - 'boolAttr1    boolAttr2'
        .trim()
        .split(/\s+/g) // split empty attributes - [ 'boolAttr1', 'boolAttr2' ]
    );
    emptyProps.forEach(function (prop) {
        if (prop) {
            // @ts-ignore
            props[prop] = true;
        }
    });
    var valuedProps = attrsPart.trim().match(/\w+\s*=\s*['"][^"]*?['"]/g); // [ 'valueAttr1="/queue"', 'valueAttr2=" value "', 'emptyAttr=""' ]
    // @ts-ignore
    valuedProps.forEach(function (match) {
        var _a = match.trim().split('='), key = _a[0], value = _a[1];
        if (value) {
            value = value.replace(/['"]/g, '');
        }
        if (value === 'true') {
            value = true;
        }
        else if (value === 'false') {
            value = false;
        }
        // @ts-ignore
        props[key] = value;
    });
    return props;
};
var getComponentChildren = function (message) {
    // @ts-ignore
    var componentName = message.match(/<(\w+)/)[1];
    // <Icon />
    if (/^<[^>]+\/>$/.test(message)) {
        // @ts-ignore
        return undefined;
    }
    // <Link to="/">bar</Link>
    // complex regex to be sure that value be matched properly even if the content is "< apple>banana<grape>"
    // @ts-ignore
    return message.match(new RegExp("<\\s*".concat(componentName, "[^>]+?>(.*)</\\s*").concat(componentName, "\\s*>")))[1];
};
var createComponent = function (message, components) {
    try {
        // @ts-ignore
        var componentName = message.match(/<(\w+)/)[1];
        var component = components[componentName];
        var props = getComponentProps(message);
        var children = getComponentChildren(message);
        return React.createElement(component, props, children);
    }
    catch (err) {
        console.error(err);
        // TODO add error handling - added on 10/12/20 by pavelivanov
        // @ts-ignore
        return null;
    }
};
/**
 * Replace components in string message with components create with React.createElement
 *
 * message: "foo <Link to="/">bar</Link> zoo <Icon /> baz <Button>kek</Button>"
 * components: { Link: Link, Icon: Icon, Button: Button }
 *
 * result:
 *
 * [
 *   "foo ",
 *   React.createElement(Link, { to: '/' }, 'bar'),
 *   " zoo ",
 *   React.createElement(Icon),
 *   " baz ",
 *   "<Href>kek</Href>",
 * ]
 */
var replaceReactComponents = function (message, components) {
    var componentNames = Object.keys(components || {});
    if (!componentNames.length) {
        return [message];
    }
    var compoRegexStr = componentNames.join('|'); // Link|Icon|Button
    var splitRegex = new RegExp("(<\\s*(?:".concat(compoRegexStr, ")(?:[^>]+?/>|.+?(?:").concat(compoRegexStr, "\\s*)>))"), 'g');
    var messageArr = message.split(splitRegex);
    return (messageArr
        .map(function (message) {
        // check that this message part contains a component
        if (new RegExp("<".concat(compoRegexStr)).test(message)) {
            return createComponent(message, components);
        }
        return message;
    })
        .filter(function (v) { return v; }));
};var Message = function (props) {
    var className = props.className, value = props.value, _a = props.tag, tag = _a === void 0 ? 'span' : _a, html = props.html, onClick = props.onClick;
    var intl = useIntl();
    if (!value) {
        // TODO handle error - added on 10/13/20 by pavelivanov
        return null;
    }
    if (typeof value === 'string') {
        if (html) {
            return React.createElement(tag, {
                className: className,
                dangerouslySetInnerHTML: { __html: value },
                onClick: onClick,
            });
        }
        // TODO handle error - added on 10/13/20 by pavelivanov
        return React.createElement(tag, { className: className, onClick: onClick }, value);
    }
    var values = value.values, components = value.components, message = __rest(value, ["values", "components"]);
    var formattedMessage = intl.formatMessage(message, values);
    if (components) {
        var formattedMessageArr = replaceReactComponents(formattedMessage, components);
        var children = formattedMessageArr.filter(function (messageItem) { return messageItem; }).map(function (messageItem, index) {
            if (typeof messageItem === 'object') {
                return React.createElement(Fragment, { key: index }, messageItem);
            }
            return React.createElement("span", { key: index, dangerouslySetInnerHTML: { __html: messageItem } });
        });
        return React.createElement(tag, { className: className, onClick: onClick }, children);
    }
    if (html) {
        return React.createElement(tag, {
            className: className,
            dangerouslySetInnerHTML: { __html: formattedMessage },
            onClick: onClick,
        });
    }
    return React.createElement(tag, { className: className, onClick: onClick }, formattedMessage);
};export{IntlProvider,Message,useIntl};